import React from 'react'
import Shifts from '../Shifts'
//@MUI
import Grid from '@mui/material/Grid'
import EventInformation from './EventInformation/EventInformation'

const CentreTabs = ({ expandedDays, setExpandedDays }) => {
  return (
    <Grid item xs={12} lg={8} display="flex" flexDirection="column" gap={2}>
      <EventInformation />
      <Shifts expandedDays={expandedDays} setExpandedDays={setExpandedDays} />
    </Grid>
  )
}

export default React.memo(CentreTabs)
